import { lazy, Suspense } from 'react';
import { CircularProgress } from '@mui/material';

import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';

const HomePage = lazy(() => import('components/DASHBOARD/home'));
const Unauthorized = lazy(() => import('components/DASHBOARD/unauthorized'))

const Home = () => {
  let { path } = useRouteMatch();

  return (
    <Suspense fallback={<CircularProgress />}>
      <Switch>
        <Route exact path={`${path}/`} component={HomePage} />

        <Route exact path={`${path}/unauthorized`} component={Unauthorized} />

        <Route path='*'>
          <Redirect to={`${path}/`} />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default Home;
